import(/* webpackMode: "eager" */ "/vercel/path0/app/products/[id]/page.jsx")